import dynamic from "next/dynamic";
import { PdfViewerProps } from "./PdfViewer";
import withLoadingProps from "./withLoadingProps";
import PdfViewerErrorMessage from "./PdfViewerErrorMessage";

const PdfViewerDynamic = withLoadingProps<PdfViewerProps>((useLoadingProps) =>
  dynamic(() => import("./PdfViewer"), {
    ssr: false,
    loading: function useLoading({ error }) {
      const props = useLoadingProps();
      if (error) {
        return <PdfViewerErrorMessage url={props.url} />;
      }
      return null;
    },
  }),
);

export default PdfViewerDynamic;
